import { Col, Container, Image, Row, Stack } from "react-bootstrap"

const AboutWhoWeAre = () => {
    return (
        <Container className="who-we-are margin-top-70 margin-bottom-70"> 
            <Row>
                <Col md="6" className="who-we-are-img">
                    <Image src="/images/who-we-are.png" />
                </Col>
                <Col md="6" className="who-we-are-column-right">
                    <Stack className="who-we-are-content">
                        <h2 className="section-title">Who <span>We Are</span></h2>
                        <p>We are a team of skilled professionals dedicated to delivering <b>high-quality web solutions</b> that drive success. With expertise in <b>front-end and back-end development</b>, we transform ideas into powerful digital experiences.</p>
                        <p>Our mission is to provide <b>custom, scalable, and innovative solutions</b> tailored to meet the unique needs of businesses. Whether it's creating stunning user interfaces, building robust applications, or optimizing performance, we ensure precision and excellence in every project.</p>
                        <p>With a commitment to <b>quality, reliability, and client satisfaction</b>, we collaborate closely with businesses to bring their visions to life. No matter the challenge, we deliver solutions that make an impact.</p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}


export default AboutWhoWeAre